import { Close } from '../../elements/icons/iconslib';
import React, { useState, useEffect } from 'react';

import styles from './inappmessages.module.scss';
import classNames from 'classnames';
import { GenericPopup } from '../genericpopup/genericpopup';
import { InappmessageModalImageText } from './partials/inappmessageModalImageText';
import { InappmessageModalGraphic } from './partials/inappmessageModalGraphic';
import { InappmessageFullImageText } from './partials/inappmessageFullImageText';
import { InappmessageFullGraphic } from './partials/inappmessageFullGraphic';

declare global {
    interface Window { braze: any; }
}

export type InappmessagesButtonType = {
  text: string;
  id: number;
  clickAction: string;
  uri?: string;
};

export type InappemessageExtras = {
  [key: string]: string;
};

export type InappmessagesProps = {
  message?: string;
  buttons: Array<InappmessagesButtonType>;
  openTarget: string;
  imageUrl: string;
  imageStyle: string;
  header?: string;
  xg: string;
  extras: InappemessageExtras;
};

export const fallbackImage = "/feed/images/crest-plain.svg";

export function Inappmessages({ data }: { data: InappmessagesProps }) {
  const [show, setShow] = useState<boolean>(true);
  const [isModal, setIsModal] = useState<boolean>(false);
  const [isFullScreen, setIsFullScreen] = useState<boolean>(false);

  useEffect(() => {
    if (!data.xg || data.xg === 'MODAL') {
      setIsModal(true);
    }
    if (data.xg === 'FULL') {
      setIsFullScreen(true);
    }
  }, [data]);

  const closePopup = () => {
    setShow(false);
  };

  const logMessageClick = () => {
    if(!window.braze) {
        return;
    }

    window.braze.logInAppMessageClick(data);
  };

  return (
    <>
      <GenericPopup
        isOpen={show}
        clickOutsideCallback={closePopup}
        isModal={isModal}
        className={styles.inAppMessagePopup}
      >
        <div className={classNames(styles.iamWrapper)} onClick={logMessageClick}>
          <span className={classNames(styles.close)} onClick={closePopup}>
            <Close />
          </span>
          {data.imageStyle === 'TOP' && isModal && (
            <InappmessageModalImageText
              data={data}
              onClosePopup={closePopup}
            ></InappmessageModalImageText>
          )}

          {data.imageStyle === 'GRAPHIC' && isModal && (
            <InappmessageModalGraphic
              data={data}
              onClosePopup={closePopup}
            ></InappmessageModalGraphic>
          )}

          {data.imageStyle === 'TOP' && isFullScreen && (
            <InappmessageFullImageText
              data={data}
              onClosePopup={closePopup}
            ></InappmessageFullImageText>
          )}

          {data.imageStyle === 'GRAPHIC' && isFullScreen && (
            <InappmessageFullGraphic
              data={data}
              onClosePopup={closePopup}
            ></InappmessageFullGraphic>
          )}
        </div>
      </GenericPopup>
    </>
  );
}
